import * as Yup from "yup";

export const percentCouponValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن نام الزامی است"),
  code: Yup.string()
  .required("وارد کردن کد الزامی است"),
  value: Yup.number()
    .required("وارد کردن مقدار الزامی است")
    .max(100,"کوپن نهایتا میتواند 100% باشد."),
});

export const priceCouponValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن نام الزامی است"),
  code: Yup.string()
  .required("وارد کردن کد الزامی است"),
  value: Yup.number()
    .required("وارد کردن مقدار الزامی است")
});